import { render, staticRenderFns } from "./FormTransfers.vue?vue&type=template&id=3b6188ca&lang=pug"
import script from "./FormTransfers.vue?vue&type=script&lang=js"
export * from "./FormTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports